import { render } from "./ValuesView.vue?vue&type=template&id=8cbe597a"
import script from "./ValuesView.vue?vue&type=script&lang=js"
export * from "./ValuesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__